/*
 * @Author: Chao Yang
 * @Date: 2019-09-29 01:20:00
 * @LastEditor: Chao Yang
 * @LastEditTime: 2019-09-29 05:43:46
 */
import { HeaderLogoItem } from './header-logo-item';
import { HeaderUserItem } from './header-user-item';
export class HeaderOption {
  constructor() {
    this.branding = '';
    this.logo = new HeaderLogoItem();
    this.user = new HeaderUserItem();
  }
  public branding: string;
  public logo: HeaderLogoItem;
  public user: HeaderUserItem;
  public logoHeight: number;
  public showAllPortfolioLink: boolean;
}
